// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const virizion: PokeData = {
  "id": 640,
  "name": "virizion",
  "height": 20,
  "weight": 2000,
  "base_experience": 261,
  "types": [
    PokeType.GRASS,
    PokeType.FIGHTING
  ],
  "api_moves": [
    "swords-dance",
    "double-kick",
    "take-down",
    "leer",
    "quick-attack",
    "giga-drain",
    "synthesis",
    "helping-hand",
    "magical-leaf",
    "leaf-blade",
    "close-combat",
    "quick-guard",
    "retaliate",
    "work-up",
    "sacred-sword"
  ],
  "moves": [
    "double-kick",
    "leer",
    "quick-attack",
    "synthesis",
    "close-combat",
    "wood-hammer",
    "overgrowth",
    "energy-ball",
    "grassy-terrain",
    "solar-beam",
    "superpower",
    "frenzy-plant",
    "vine-whip"
  ],
  "evolution_chain": {
    "id": 327,
    "item": null,
    "species": [
      {
        "name": "virizion",
        "order": 641,
        "types": [
          PokeType.GRASS,
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 130,
    "speed": 147,
    "ability_power": 123
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
